module.exports = __webpack_public_path__ + "static/media/Train-1.ae56abae.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Train-1.png
// module id = 326
// module chunks = 0